module.exports = __webpack_public_path__ + "img/otp-phone.a1fcfdd4.jpg";